export const CONTACT_EMAIL = 'info@darsinitiative.org';
export const NIZAM_ELEMENT_ID = 'el_9gp4s03x';
export const SITE_URL = 'https://darsinitiative.org';

export const ABOUT_VIDEO_YOUTUBE_URL = 'https://www.youtube.com/watch?v=gxDpDi7ANrQ';

export const SOCIAL_LINKS = {
  youtube: 'https://www.youtube.com/@darsinitiative',
  instagram: 'https://www.instagram.com/darsinitiative?igsh=aHZpN25zYmYwazRi&utm_source=qr',
  tiktok: 'https://www.tiktok.com/@dars.initiative?_t=ZT-8y1iy8Whr6T&_r=1',
};

export const DEFAULT_METRICS = {
  masajidDeepCleaned: 3,
  masjidPartners: '10+',
  volunteers: '200+',
};

export const MASAJID_PARTNERS = [
  'Masjid Al-Farooq',
  'Masjid Al-Furqan (West Cobb Islamic Center / WCIC)',
  'Masjid Taqwa',
  'Masjid Al-Momineen',
  'Masjid Al-Ummati',
  'Muad Bin Jabal',
  'One Ummah Center',
  'Madina Institute',
  'Al-Huda Islamic Center',
  'East Cobb Islamic Center (ECIC)',
  'Darul Arqam',
];

// Future admin field: flyers: [{ url, label?, position? }]
// Legacy single flyer: flyerUrl + flyerPosition (still supported)
export const CALENDAR_SEED = [
  { month: 'June', year: 2026, title: 'Summer Intensive Start', isFlagship: true, startDate: '2026-06-01' },
  { month: 'July', year: 2026, title: 'Standard Service Event', isFlagship: false, startDate: '2026-07-15' },
  {
    month: 'August',
    year: 2026,
    title: 'Standard Service Event & Quran Night',
    items: ['Standard Service Event', 'Quran Night'],
    isFlagship: false,
    startDate: '2026-08-15',
  },
  { month: 'September', year: 2026, title: 'Standard Service Event', isFlagship: false, startDate: '2026-09-15' },
  {
    month: 'October',
    year: 2026,
    title: 'Standard Service Event, Quran Night, and Quran Competition Registration Opens',
    items: ['Standard Service Event', 'Quran Night', 'Quran Competition Registration Opens'],
    isFlagship: false,
    startDate: '2026-10-01',
  },
  {
    month: 'November',
    year: 2026,
    title: 'Clothing Drive Launch & Dedicated Sorting Event',
    items: ['Clothing Drive Launch', 'Dedicated Sorting Event'],
    isFlagship: false,
    startDate: '2026-11-01',
  },
  { month: 'December', year: 2026, title: 'Warmth & Wisdom (Flagship Humanitarian Service Event)', isFlagship: true, startDate: '2026-12-14' },
  {
    month: 'January',
    year: 2027,
    title: 'Standard Service Event, Quran Night, and Quran Competition Registration Closes',
    items: ['Standard Service Event', 'Quran Night', 'Quran Competition Registration Closes'],
    isFlagship: false,
    startDate: '2027-01-15',
  },
  { month: 'February', year: 2027, title: 'Iftar Preparation (Flagship Ramadan Packing Event)', isFlagship: true, startDate: '2027-02-15' },
  { month: 'March', year: 2027, title: 'Eid Preparation & Prayer Hall Setup Support', isFlagship: false, startDate: '2027-03-15' },
  { month: 'April', year: 2027, title: 'Annual Quran Competition', isFlagship: true, startDate: '2027-04-04' },
  { month: 'May', year: 2027, title: 'Quran Night Focus', isFlagship: false, startDate: '2027-05-15' },
];

export const MEDIA_SLOTS = {
  hero: { aspectRatio: '21/9', label: 'Home Hero' },
  aboutVideo: { aspectRatio: '16/9', label: 'About Intro Video' },
  appPreview: { aspectRatio: '9/16', label: 'Dars App Preview' },
  warmthWisdom: { aspectRatio: '16/9', label: 'Warmth & Wisdom' },
  iftarPacking: { aspectRatio: '16/9', label: 'Iftar Packing' },
  masjidIftaar: { aspectRatio: '16/9', label: 'Masjid Iftaar Catering' },
  quranCompetition: { aspectRatio: '16/9', label: 'Quran Competition' },
  oneUmmahPartner: { aspectRatio: '1/1', label: 'One Ummah Project (collaborator)' },
  partnerLogo1: { aspectRatio: '3/2', label: 'Partner Logo 1 (MSA / Collaborator)' },
  partnerLogo2: { aspectRatio: '3/2', label: 'Partner Logo 2' },
  partnerLogo3: { aspectRatio: '3/2', label: 'Partner Logo 3' },
  partnerLogo4: { aspectRatio: '3/2', label: 'Partner Logo 4' },
  heroStat1: { aspectRatio: '4/3', label: 'Hero Stat Card 1' },
  heroStat2: { aspectRatio: '4/3', label: 'Hero Stat Card 2' },
  heroStat3: { aspectRatio: '4/3', label: 'Hero Stat Card 3' },
};

export const HOME_METRICS = [
  { value: '1,250+', label: 'Iftaar Meals' },
  { value: '1,200+', label: 'Homeless Fed' },
  { value: '300', label: 'Hygiene Kits' },
  { value: '3', label: 'Masajid Cleaned' },
  { value: '10+', label: 'Masjid Partners' },
];
